import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { getConsent, setConsent, captureUTMs, initAnalytics } from '../services/analytics';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Always capture UTMs on first paint, regardless of consent.
    captureUTMs();

    const stored = getConsent();
    if (stored === 'granted') {
      initAnalytics();
      setVisible(false);
    } else if (stored === 'denied') {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent('granted');
    setVisible(false);
  };
  const decline = () => {
    setConsent('denied');
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[60] rounded-2xl p-5"
      style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-card)',
        boxShadow: 'var(--shadow-card-lg)',
        backdropFilter: 'blur(var(--glass-blur))',
        WebkitBackdropFilter: 'blur(var(--glass-blur))',
      }}
    >
      <button
        onClick={decline}
        aria-label="Dismiss"
        className="absolute top-3 right-3 p-1 rounded-md transition-colors duration-200"
        style={{ color: 'var(--text-muted)' }}
        onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg-hover)')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
      >
        <X className="w-4 h-4" />
      </button>

      <h3 className="text-sm font-semibold mb-1.5 pr-6" style={{ color: 'var(--text-heading)' }}>
        We use cookies to improve your experience
      </h3>
      <p className="text-xs leading-relaxed mb-4" style={{ color: 'var(--text-body)' }}>
        We use analytics and advertising cookies to understand how you use our site and to show
        relevant ads on other platforms. You can decline without affecting site functionality.
      </p>

      <div className="flex flex-col-reverse sm:flex-row gap-2">
        <button
          onClick={decline}
          className="flex-1 px-4 py-2 rounded-lg text-xs font-medium transition-all duration-200"
          style={{
            color: 'var(--text-accent)',
            border: '1px solid var(--border-btn)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg-hover)')}
          onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        >
          Decline
        </button>
        <button
          onClick={accept}
          className="flex-1 px-4 py-2 rounded-lg text-xs font-semibold text-white transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
          style={{
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            boxShadow: 'var(--shadow-btn-sm)',
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
